var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0A79AA;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded",
    transform: "translate(-749.000000, -1263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communication",
    transform: "translate(100.000000, 1162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(646.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st0",
    points: "0,0 24,0 24,24 0,24  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,15.2L16.7,15c-0.6-0.1-1.2,0.1-1.6,0.6l-1.8,1.8c-2.8-1.4-5.1-3.7-6.6-6.6l1.9-1.9 c0.4-0.4,0.6-1,0.6-1.6L8.8,4.8c-0.1-1-1-1.8-2-1.8H5C3.9,3,3,3.9,3,5.1c0.5,8.5,7.4,15.4,15.9,15.9C20,21,21,20.1,21,19v-1.7 C21,16.2,20.2,15.4,19.2,15.2z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4251d386d29a1fa823d61d32cd4f8fd3.svg";
export { ForwardRef as ReactComponent };